import React from 'react';
import PropTypes from 'prop-types';
import './TextArea.css';

/**
 * TextArea - Standardized textarea component
 * Multi-line text input with auto-resize option
 */
const TextArea = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  rows = 3,
  maxLength,
  className = '',
  resize = 'vertical',
  autoResize = false,
}) => {
  const handleChange = (e) => {
    if (autoResize) {
      e.target.style.height = 'auto';
      e.target.style.height = `${e.target.scrollHeight}px`;
    }
    onChange(e);
  };

  return (
    <div className={`ml-textarea ${className}`}>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        rows={rows}
        maxLength={maxLength}
        className={`ml-textarea__control ml-textarea__control--${resize}`}
      />
      {maxLength && (
        <div className="ml-textarea__counter">
          {value?.length || 0} / {maxLength}
        </div>
      )}
    </div>
  );
};

TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  className: PropTypes.string,
  resize: PropTypes.oneOf(['none', 'vertical', 'horizontal', 'both']),
  autoResize: PropTypes.bool,
};

export default TextArea;
